import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';

import {
  AlertService,
  AuthenticationService,
  ComplianceAreaService,
  ControlItemsService,
  TenantService,
} from '../../_services/index';

import {ComplianceArea, ControlItem, User,} from '../../_models/index';

import {MenuItem} from 'primeng/api';

import {Role} from '../../helpers/role';
import {Constants} from '../../helpers/constants';

@Component({
    standalone: false,
  selector: "control-items-component",
  templateUrl: 'control.item.updates.component.html',
  styleUrls: ['./control.item.updates.component.scss'],
})

export class ControlItemUpdatesComponent implements OnInit {
  projectId: string;
  controlItems: ControlItem[];
  msg: string;
  currentUser: User;
  upload: any;
  canManageControlItems: Boolean;
  canUploadComplianceArea: boolean;
  complianceAreas: ComplianceArea[];
  selectedComplianceArea: ComplianceArea;
  menuItems: MenuItem[];
  selectedItems: number[] = [];
  rowGroupMetadata: any = {};

  constructor(
    public route: ActivatedRoute,
    public router: Router,
    public controlItemsService: ControlItemsService,
    public authenticationService: AuthenticationService,
    public alertService: AlertService,
    public complianceAreaService: ComplianceAreaService,
    public tenantService: TenantService) {
    //this.projectId = route.snapshot.params['projectId'];
  }

  ngOnInit() {

    this.currentUser = JSON.parse(sessionStorage.getItem('currentUser'));

    const tenantName = this.getTenantName();
    if (tenantName == null) {
      this.authenticationService.logout();

      return;
    }

    this.canManageControlItems = (this.currentUser.role & Role.PrimaryAdvisorLead | Role.PlatformSupport) != 0;

    if (tenantName == Constants.RiskSpongeMaster) {
      this.canUploadComplianceArea = true;
    } else {
      this.tenantService.getCurrent().subscribe(data => {
        this.canUploadComplianceArea = (this.currentUser.role & (Role.KingAdmin | Role.PrimaryAdvisorLead | Role.PlatformSupport)) != 0 && data.canCreateComplianceArea;
      });
    }

    this.loadControlItems();
  }

  public loadControlItems() {
    const tenantName = this.getTenantName();
    if (tenantName == null) {
      this.authenticationService.logout();

      return;
    }

    this.complianceAreaService.getComplianceAreaUpdate(tenantName).subscribe(c => {
        this.controlItems = c;
        this.updateRowGroupMetadata();
      }
    );
  }


  getTenantName(): string {
    if (this.currentUser == null) {
      return null;
    }

    return this.currentUser.tenantName;
  }

  approveUpdates() {
    const tenantName = this.getTenantName();
    if (tenantName == null) {
      this.authenticationService.logout();

      return;
    }

    this.complianceAreaService.approveUpdates(this.selectedItems, tenantName).subscribe(c =>
      this.loadControlItems()
    );
  }

  rejectUpdates() {
    const tenantName = this.getTenantName();
    if (tenantName == null) {
      this.authenticationService.logout();

      return;
    }

    this.complianceAreaService.rejectUpdates(this.selectedItems, tenantName).subscribe(c =>
      this.loadControlItems()
    );
  }

  areaSelected(value, id) {
    if (value) {
      this.selectedItems.push(id);
    } else {
      this.selectedItems = this.selectedItems.filter(i => i != id);
    }
  }

  updateRowGroupMetadata() {
    this.rowGroupMetadata = {};
    if (this.controlItems) {
      for (let i = 0; i < this.controlItems.length; i++) {
        let rowData = this.controlItems[i];
        let brand = rowData.complianceAreaId;
        if (i == 0) {
          this.rowGroupMetadata[brand] = {index: 0, size: 1};
        } else {
          let previousRowData = this.controlItems[i - 1];
          let previousRowGroup = previousRowData.complianceAreaId;
          if (brand == previousRowGroup) {
            this.rowGroupMetadata[brand].size++;
          } else {
            this.rowGroupMetadata[brand] = {index: i, size: 1};
          }
        }
      }
    }
  }
}
